export class BoundsService {
  static outOfBounds(event: PointerEvent, rect: DOMRect, margin = 0) {
    const positionEvent =
      window.TouchEvent && event instanceof TouchEvent
        ? event.touches[0]
        : event;

    return (
      positionEvent.pageX < rect.x - margin ||
      positionEvent.pageX > rect.x + rect.width + margin ||
      positionEvent.pageY < rect.y - margin ||
      positionEvent.pageY > rect.y + rect.height + margin
    );
  }

  static inBounds(event: PointerEvent, rect: DOMRect, margin = 0) {
    return !BoundsService.outOfBounds(event, rect, margin);
  }

  static getCenterOfRect(rect: DOMRect, isHorizontal = false): number {
    return isHorizontal ? rect.x + rect.width / 2 : rect.y + rect.height / 2;
  }
}
